import { type ReactElement, useState, FormEvent, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm, SubmitHandler } from "react-hook-form";
import { AppDispatch, RootState } from "src/app/store";
import userImage from "../../../assests/Icons/user.svg";
import { forgotPassword } from "../hooks/forgotPassword";

type forgotPasswordFields = {
	EmailId: string;
}

export default function ForgotPasswordForm(): ReactElement {
	const { register, watch, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm<forgotPasswordFields>();
	const dispatch = useDispatch<AppDispatch>();
	const { forgotPasswordError, response } = useSelector((state: RootState) => state.forgotPassword);
	const [responseMessage, setResponseMessage] = useState("");

	const onSubmit: SubmitHandler<forgotPasswordFields> = async (data) => {
		await dispatch(forgotPassword(data));
	}

	useEffect(() => {
		if (response !== null) {
			setResponseMessage(response);
		}
		if (forgotPasswordError !== null) {
			setError("root", {
				message: forgotPasswordError,
			})
		}
	}, [forgotPasswordError, response])

	return <>
		<div className="w-full p-6 max-md:max-w-lg mx-auto">
			<form onSubmit={handleSubmit(onSubmit)}>
				<div className="mb-8">
					<h3 className="text-gray-800 text-3xl font-bold">Reset Password</h3>
				</div>

				<div className="mt-8">
					<label className="text-gray-800 text-[15px] mb-2 block">Email</label>
					<div className="relative flex items-center">
						<input type="text" className="w-full text-sm text-gray-800 bg-gray-100 focus:bg-transparent pl-4 pr-10 py-3.5 rounded-xs outline-blue-600" placeholder="Enter email" {...register("EmailId", { required: "Email is required", pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: "Enter a valid Email Address" }, })} />
						<img src={userImage} className="w-[18px] h-[18px] absolute right-4" alt="login-image" />
					</div>
					{errors.EmailId && (
						<div className="text-red-500">{errors.EmailId.message}</div>
					)}
				</div>
				<div className="mt-8">
					<button disabled={isSubmitting} type="submit" className="w-full py-3 px-4 text-sm tracking-wide rounded-xs text-white bg-blue-600 hover:bg-blue-700 focus:outline-none">
						{isSubmitting ? "Resetting..." : "Reset"}
					</button>
				</div>
				<div className="mt-8 text-center text-blue">
					<label htmlFor="">{responseMessage}</label>
				</div>
			</form>
			{errors.root && (
				<div className="flex justify-center font-bold text-red-500 pt-4">{errors.root.message}</div>
			)}
		</div>
	</>
}
